import { render, staticRenderFns } from "./ucCompany.vue?vue&type=template&id=53824572&scoped=true&"
import script from "./ucCompany.vue?vue&type=script&lang=js&"
export * from "./ucCompany.vue?vue&type=script&lang=js&"
import style0 from "./ucCompany.vue?vue&type=style&index=0&id=53824572&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53824572",
  null
  
)

export default component.exports